import microGlp1Followup from './followup';
import microGlp1 from './intial';

const microGlp1Flows = {
  microGlp1,
  microGlp1Followup
};
export default microGlp1Flows;
